import type { Brand } from "@/types";

/**
 * 국내 주요 멸균우유 브랜드 — 대행 물류시 상차 리스트에 사용.
 * 리서치 결과(2026-04 기준):
 *  - 서울우유 멸균 / 매일우유 멸균(ESL 포함) / 남양 맛있는 우유 GT 멸균 /
 *    연세우유 멸균 / 동원 덴마크 멸균 / 파스퇴르 멸균 / 빙그레 바나나우유 멸균 등
 */
export const BRAND_COLORS: Record<Brand, string> = {
  "서울우유": "bg-blue-100 text-blue-700",
  "매일우유": "bg-yellow-100 text-yellow-700",
  "남양유업": "bg-rose-100 text-rose-700",
  "연세우유": "bg-emerald-100 text-emerald-700",
  "덴마크(동원)": "bg-indigo-100 text-indigo-700",
  "파스퇴르": "bg-amber-100 text-amber-700",
  "빙그레": "bg-pink-100 text-pink-700",
  "기타": "bg-slate-100 text-slate-700",
};
